import EurodimaLogo from '@/components/assets/EurodimaLogo';
import { CreateCompany } from '@/features/company-admin';
import { cn } from '@/lib';
import { scrollStyleClass } from '@/utils/scrollClassHelper';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

function AddMyCompanyPage() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    return (
        <div className="full-screen flex flex-col items-center justify-start p-4 full-screen">
            <div className={cn("w-full max-w-2xl overflow-auto", scrollStyleClass)}>
                <div className="flex absolute top-0 left-0 bg-surface z-10 w-full">
                    <div className="h-10 mt-6 ml-6 mb-2">
                        <EurodimaLogo />
                    </div>
                </div>

                <h1 className="text-2xl font-bold text-center mb-2 text-onsurface mt-20">
                    {t('createCompany.title')}
                </h1>
                <p className="text-center text-muted mb-8">
                    {t('createCompany.subtitle')}
                </p>
                <div className="px-5 space-y-5 flex flex-col bg-surface border border-border shadow-sm rounded-xl mx-auto justify-center items-center py-10">
                    <CreateCompany
                        onCreatedSuccessfully={() => navigate({ to: '/' })}
                        withCompanyContact={true}
                    />
                </div>
            </div>
        </div>
    );
}

export const Route = createFileRoute('/_authenticated/addMyCompany')({
    component: AddMyCompanyPage,
});
